import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AmbassadorsProfileService } from 'projects/admin/src/app/features/user-management/consumer-ambassadors/services/connect/ambassadors-profile.service';
 import Swal from 'sweetalert2';
export interface DialogData {
  record: any;
}
@Component({
  selector: 'app-cv-resume-form',
  standalone: false,
  templateUrl: './cv-resume-form.component.html'
})
export class CvResumeFormComponent implements OnInit {
  files: any[] = []
  isSubmited = false
  loading = false
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<CvResumeFormComponent>,
    private service: AmbassadorsProfileService,
    private translate: TranslateService) {

  }
  ngOnInit(): void {
    if (this.data.record) this.files = [this.data.record]
  }

  saveRecord() {
    this.isSubmited = true
    if (this.files.length && this.files?.[0] instanceof File) {
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.files[0]);
      this.service.UploadAmbassadorCv(formData).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.data.record ? this.translate.instant('swalMsg.updatedsuccessfully') : this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true)
      }, error => {
        this.loading = false;

        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
        }
      });
    }
  }

}
